import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Injectable, Injector, OnDestroy, OnInit, QueryList, signal, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core'
import { FormBuilder, FormControl, FormGroup } from '@angular/forms'
import { MatDatepicker } from '@angular/material/datepicker'
import { MatDialog } from '@angular/material/dialog'
import { AbstractComponent, AttendanceDashboardOverview, AttendanceGoalsConfig, AttendanceGoalsPayload, AttendanceInsight, AttendanceLiveSnapshot, CampaignService, Channel, CHANNEL_ICONS, channelIconOf, ChannelService, ChannelTypeEnum, ChatbotLoggingService, ContactService, DashboardService, Department, DepartmentJourney, DepartmentService, GoalStatus, ModalResponseAttendanceComponent, Pager, Team, TeamService, User, UserService } from 'lib-trend-core'
import { BehaviorSubject, debounceTime, distinctUntilChanged, Subject, takeUntil, } from 'rxjs'

interface DashboardMessage {
  name: string
  message: string
}

interface DashboardAttendancesKPIs {
  tmfh: string;
  tme: string;
  tma: string;
  tmp: string;
  tmta: string;
  countOvertime: number;
  countPending: number;
  countInProgress: number;
  countPaused: number;
  countClosed: number;
}

export interface ResponseDashTypes {
}

interface Campaign {
  channelName: string
  coust: number
  totalMessages: number
  totalRecord: number
  type: ChannelTypeEnum
  hybrid?: boolean
}

interface AttendanceOnlineTypes {
  contact: string
  user: string
  email: string
  channel: string
  totalChat: number
  totalMessages: number
  totalInProgress: number
  totalClosed: number
  totalOvertime: number
  totalPaused: number
  totalPending: number
  limitAttendancePerAttendant: boolean
  maxNumberAttendanceAttendant: number
}

export interface MostAcessedMenuData { menu: string[]; count: number }

type DashboardType = 'ATTENDANCES' | 'CRM' | 'TASKS';

/** Which view of "Ritmo da operação" is open. */
type RhythmView = 'HOUR' | 'SHIFT' | 'WEEKDAY' | 'CHANNEL';

@Component({
    selector: 'dashboard-component',
    // templateUrl: './dashboard.component.html',
    templateUrl: './dashboard.v2.component.html',
    // styleUrls: [`./dashboard.component.scss`],
    styleUrls: ['./dashboard.v2.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Injectable()
export class DashboardComponent extends AbstractComponent implements OnInit, OnDestroy, AfterViewInit {

  dashboardAttendancesKPIs: DashboardAttendancesKPIs;
  messages: DashboardMessage[] = [];
  department: Department[];
  userAttendant: User[];
  channelAttendant: Channel[];
  attendanceOn: Pager<AttendanceOnlineTypes> = new Pager<AttendanceOnlineTypes>({ perPage: 10 });
  listTeam: Array<Team> = new Array<Team>();
  listTeamChannel: Array<Team> = new Array<Team>();
  attendantsByTeam: Array<User> = new Array<User>();
  msgControl = new FormControl('');
  destroyed$ = new Subject();
  dashByHour = {};
  peakAttendance = [];
  newContact = [];
  newContactWeekend = [];
  campaign: Campaign[] = [];
  pager: Pager<User> = new Pager<User>({ perPage: 10 });

  viewLine: [number, number] = [400, 260];
  onlineUsers: any[] = [];

  viewLC: [number, number] = [700, 400];

  viewAP: [number, number] = [1000, 400];
  legendLC = false;
  colorScheme: any = {
    domain: ['#0acf97', '#4213f6'],
  };

  @ViewChildren('ContainerLineRef') containers!: QueryList<ElementRef>;

  dataByHours: any[] = [];
  dashForm: FormGroup;
  @ViewChild('picker', { static: true }) picker: MatDatepicker<Date>;

  loadingSpinnerSubject = new BehaviorSubject<boolean>(true);
  loadingSpinner$ = this.loadingSpinnerSubject.asObservable();

  showError = false;

  labelChannel: string = '';
  labelDepartment: string = '';
  labelAttendant: string = '';

  overallRating: Record<string, number> = {};
  totalContacts: string;;
  mostAccessedMenus: Array<MostAcessedMenuData> = [];

  sortedAttendanceList: AttendanceOnlineTypes[] = [];
  sortedBirthdayList: User[] = [];
  sortedMenuList: MostAcessedMenuData[] = [];

  activeDashboard = signal<DashboardType>('CRM');;

  /** The live cards at the top — refreshed with the filters, never with the period. */
  attendanceLive: AttendanceLiveSnapshot;

  /** Everything the period sections read from. */
  overview: AttendanceDashboardOverview;

  /** Four readings are shown; the rest sit behind "ver todas as leituras". */
  showAllInsights = false;

  rhythmView: RhythmView = 'HOUR';

  /** Arrivals per hour split into the two series the stacked chart draws. */
  arrivalsByHourSeries: Array<{ name: string; series: Array<{ name: string; value: number }> }> = [];

  /** How many departments the journey panel shows before "see all". */
  readonly journeyPreviewSize = 6;

  showAllJourney = false;

  goalsPayload: AttendanceGoalsPayload;
  goalsForm: FormGroup;
  savingGoals = false;

  constructor(
    injetor: Injector,
    private dashboardService: DashboardService,
    public departmentService: DepartmentService,
    public userService: UserService,
    public contactSerivce: ContactService,
    public channelService: ChannelService,
    public chatbotLoggingService: ChatbotLoggingService,
    private teamService: TeamService,
    public dialog: MatDialog,
    private fb: FormBuilder,
    public campaignService: CampaignService,
    private cdr: ChangeDetectorRef
  ) {
    super(injetor);
    this.loadingContent = true;
  }

  ngOnInit(): void {
    this.createForm();
    this.createGoalsForm();
    this.loadGoals();
    this.initializeData();
    this.initFilters();
    this.getByBirthday();

    this.dashForm.valueChanges
      .pipe(
        takeUntil(this.destroy$),
        debounceTime(300),
        distinctUntilChanged(
          (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)
        )
      )
      .subscribe((val) => {
        this.onFormChange(val);
      })
    this.getContactList();
  }

  setDashboardType(type: DashboardType) {
    this.activeDashboard.set(type);
  }

  ngAfterViewInit(): void {
    this.containers.changes.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.resizeAllCharts();
    })

    setTimeout(() => this.resizeAllCharts(), 50);
    window.addEventListener('resize', this.onResize);
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.resizeAllCharts();
  }

  /**
   * Size every chart from the NARROWEST host on screen.
   *
   * It used to take the widest, which worked while every view held one full-width chart and
   * broke the moment one held two side by side: both were drawn at the card's full width,
   * spilled out of it and printed their labels over each other. The narrowest host is the
   * only width that fits all of them, and the hosts carry `overflow-hidden` so a chart drawn
   * too wide can no longer stretch the very element it is measured from.
   */
  private resizeAllCharts(): void {
    const widths = this.containers
      .map((container) => container.nativeElement.offsetWidth)
      .filter((width: number) => width > 0);

    if (!widths.length) {
      return;
    }

    this.viewLine = [Math.min(...widths), 260];
    this.cdr.detectChanges();
  }

  onDateSelected() {
    const dateStart = this.dashForm.get('dateRange.dateStart')?.value;
    const dateEnd = this.dashForm.get('dateRange.dateEnd')?.value;
    if (dateStart && dateEnd) {
      this.picker.close();
    }
  }

  private initFilters() {
    this.getByAllChannel();
    this.getListTeam();
    if (this.isAdmin()) {
      this.getByUserAttendant();
    }
  }

  private initializeData() {
    const formsValue = {
      dateStart: this.dashForm.value.dateRange.dateStart,
      dateEnd: this.dashForm.value.dateRange.dateEnd,
      department:
        this.dashForm.value.department === -1
          ? null
          : this.dashForm.value.department,
      attendant:
        this.dashForm.value.attendant === -1
          ? null
          : this.dashForm.value.attendant,
      channel:
        this.dashForm.value.channel === -1 ? null : this.dashForm.value.channel,
    };
    this.fetchData(formsValue);
  }

  private fetchData(formsValue?: any) {
    if (!formsValue) {
      formsValue = {
        dateStart: this.dashForm.value.dateRange.dateStart,
        dateEnd: this.dashForm.value.dateRange.dateEnd,
        department:
          this.dashForm.value.department === -1
            ? null
            : this.dashForm.value.department,
        attendant:
          this.dashForm.value.attendant === -1
            ? null
            : this.dashForm.value.attendant,
        channel:
          this.dashForm.value.channel === -1
            ? null
            : this.dashForm.value.channel,
      };
    }

    this.getDashboardAttendancesKPIs(formsValue);
    this.getAttendancesLive(formsValue);
    this.getAttendancesOverview(formsValue);
    this.getDashByHours(formsValue);
    this.getPeakAttendance(formsValue);
    this.getNewContact(formsValue);
    this.getDataAnalytics(formsValue);
    this.getAttandanceOnline(formsValue);
    this.dateDashPeakNewContact(formsValue);
    this.getOnlineUsersByCompany();
    this.getMostAccessedMenus(formsValue);
  }

  onFormChange(changes: any) {
    if (changes.dateRange.dateStart && changes.dateRange.dateEnd) {
      const formsValue = {
        dateStart: changes.dateRange.dateStart,
        dateEnd: changes.dateRange.dateEnd,
        department: changes.department === -1 ? null : changes.department,
        attendant: changes.attendant === -1 ? null : changes.attendant,
        channel: changes.channel === -1 ? null : changes.channel,
      };

      this.fetchData(formsValue);
    }
  }

  sendMessage(): void {
    this.msgControl.setValue('');
  }

  private createForm(): void {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 7);

    this.dashForm = this.fb.group({
      dateRange: this.fb.group({
        dateStart: [yesterday, []],
        dateEnd: [today, []],
      }),
      department: [-1],
      attendant: [-1],
      channel: [-1],
    });
  }

  onPeriodChange(event: any) {
    const today = new Date()
    switch (event.value) {
      case '1':
        this.dashForm.get('dateRange').patchValue({
          dateStart: new Date(),
          dateEnd: new Date(),
        });
        this.picker.close();
        break;
      case '7':
        this.dashForm.get('dateRange').patchValue({
          dateStart: new Date(today.setDate(today.getDate() - 7)),
          dateEnd: new Date(),
        })
        this.picker.close();
        break;
      case '15':
        this.dashForm.get('dateRange').patchValue({
          dateStart: new Date(today.setDate(today.getDate() - 15)),
          dateEnd: new Date(),
        })
        this.picker.close();
        break;
      case '30':
        this.dashForm.get('dateRange').patchValue({
          dateStart: new Date(today.setDate(today.getDate() - 30)),
          dateEnd: new Date(),
        })
        this.picker.close();
        break;
      case '60':
        this.dashForm.get('dateRange').patchValue({
          dateStart: new Date(today.setDate(today.getDate() - 60)),
          dateEnd: new Date(),
        });
        this.picker.close();
        break;
    }
  }

  getDashboardAttendancesKPIs({ dateStart, dateEnd, department, attendant, channel }) {
    this.dashboardService.getDashboardAttendancesKPIs(dateStart, dateEnd, department, attendant, channel)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (dashboardAttendancesKPIs) => this.dashboardAttendancesKPIs = dashboardAttendancesKPIs,
        complete: () => (this.loadingContent = false),
      })
  }

  getMostAccessedMenus({ dateStart, dateEnd, channel }) {
    const params: Record<string, string> = {};
    if (dateStart) params['dateStart'] = dateStart instanceof Date ? dateStart.toISOString() : dateStart;
    if (dateEnd) params['dateEnd'] = dateEnd instanceof Date ? dateEnd.toISOString() : dateEnd;
    if (channel) params['channel'] = channel;

    this.chatbotLoggingService.getMostAccessedMenus(params).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res: MostAcessedMenuData[]) => {
        this.mostAccessedMenus = res;
      }
    })
  }

  getDashByHours({ dateStart, dateEnd, department, attendant, channel }) {
    this.dashboardService.getAttendanceDashByHours(dateStart, dateEnd, department, attendant, channel)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (dresponseDash) => {
          this.dataByHours = dresponseDash.map((day) => {
            return {
              name: `${day.hour}:00`,
              value: day.totalAttendance,
            }
          })
        },
        complete: () => (this.loadingContent = false),
      })
  }

  getDepartmentByChannel() {
    const channel = this.dashForm.get('channel').value
    if (channel && channel !== -1) {
      this.departmentService.getDepartmentsByChannel(channel).pipe(takeUntil(this.destroy$)).subscribe({
        next: (dresponseDepart: Department[]) => {
          this.department = dresponseDepart
        },
        complete: () => (this.loadingContent = false),
      })
    } else {
      this.department = [];
    }
  }

  getByUserAttendant() {
    this.userService.findByAttendant().pipe(takeUntil(this.destroy$)).subscribe({
      next: (users: User[]) => {
        this.userAttendant = users
      },
      complete: () => (this.loadingContent = false),
    });
  }

  getByAllChannel() {
    this.channelService.getByAllChannel().pipe(takeUntil(this.destroy$)).subscribe({
      next: (channel: Channel[]) => {
        this.channelAttendant = channel;
      },
      complete: () => (this.loadingContent = false),
    })
  }

  private getListTeam(): void {
    this.teamService.getList().pipe(takeUntil(this.destroy$)).subscribe({
      next: (list: Array<Team>) => {
        this.listTeam = list
          .filter((team: Team) => {
            if (this.isAdmin()) return true;
            const userId = this.getCurrentUserUser()._id
            const isAgent = team.agents.some(
              (agent: User) => agent._id === userId
            )
            const isSupervisor = team.supervisors.some(
              (supervisor: User) => supervisor._id === userId
            )
            return isAgent || isSupervisor
          })
          .filter(
            (team: Team) => team.department && team.department.removed !== true
          );
      }
    });
  }

  loadPage(page: number) {
    this.pager.page = page;
    this.getByBirthday();
  }

  loadPageOnline(page: number) {
    this.pager.page = page;
    const formsValue = {
      dateStart: this.dashForm.value.dateRange.dateStart,
      dateEnd: this.dashForm.value.dateRange.dateEnd,
      department:
        this.dashForm.value.department === -1
          ? null
          : this.dashForm.value.department,
      attendant:
        this.dashForm.value.attendant === -1
          ? null
          : this.dashForm.value.attendant,
      channel:
        this.dashForm.value.channel === -1 ? null : this.dashForm.value.channel,
    };
    this.getAttandanceOnline(formsValue);
    this.getOnlineUsersByCompany();
  }

  getByBirthday() {
    this.contactSerivce
      .getByBirthday(this.pager.page, this.pager.perPage)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (users: any) => {
          this.pager = users
        },
        complete: () => (this.loadingContent = false),
      })
  }

  private weekdayLabel(order: number): string {
    const keys = ['', 'weekdaySunday', 'weekdayMonday', 'weekdayTuesday', 'weekdayWednesday', 'weekdayThursday', 'weekdayFriday', 'weekdaySaturday'];
    return this.t('dashboard.dashboard.' + (keys[order] ?? 'weekdaySunday'));
  }

  getPeakAttendance({ dateStart, dateEnd, department, attendant, channel }) {
    this.dashboardService
      .getPeakAttendance(dateStart, dateEnd, department, attendant, channel)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (peak) => {
          this.peakAttendance = peak.map((day) => {
            return {
              name: this.weekdayLabel(day.order),
              value: day.count,
            };
          });
        },
        complete: () => (this.loadingContent = false),
      });
  }

  dateDashPeakNewContact({ dateStart, dateEnd, department, attendant, channel }) {
    this.dashboardService.dateDashPeakNewContact(dateStart, dateEnd, department, attendant, channel)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (contact) => {
          this.newContactWeekend = contact.map((contacts) => {
            return {
              name: this.weekdayLabel(contacts.order),
              value: contacts.count,
            }
          })
        },
        complete: () => (this.loadingContent = false),
      });
  }

  getNewContact({ dateStart, dateEnd, department, attendant, channel }) {
    this.dashboardService
      .getNewContact(dateStart, dateEnd, department, attendant, channel)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (contact) => {
          this.newContact = contact.map((contacts) => {
            return {
              name: contacts.channelName,
              value: contacts.count,
            }
          })
        },
        complete: () => (this.loadingContent = false),
      });
  }

  getAttandanceOnline({ dateStart, dateEnd, department, attendant, channel }) {
    this.loadingSpinnerSubject.next(true)
    this.dashboardService
      .dateDashAttandanceOnline(
        dateStart,
        dateEnd,
        department,
        attendant,
        channel,
        this.pager.page,
        this.pager.perPage
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (attandenceOnline) => {
          this.attendanceOn = attandenceOnline;
          // Two derived columns the table sorts on like any other number: the share of an
          // attendant's chats already closed, and how many messages each chat took.
          (this.attendanceOn?.list ?? []).forEach((row: any) => {
            const chats = Number(row?.totalChat ?? 0);
            row.closedSharePercent = chats ? (Number(row?.totalClosed ?? 0) / chats) * 100 : 0;
            row.messagesPerChatValue = chats ? Number(row?.totalMessages ?? 0) / chats : 0;
          });
        },
        complete: () => this.loadingSpinnerSubject.next(false),
      });
  }

  getContactList(): void {
    this.contactSerivce.getTotalizerContact().pipe(takeUntil(this.destroy$)).subscribe(res => {
      this.totalContacts = res.map(item => item.count).reduce((acc, curr) => acc + curr, 0).toString();
    });

  }

  getDataAnalytics(query: any): void {
    this.campaignService.getDataAnalyticsDash(query).pipe(takeUntil(this.destroy$)).subscribe({
      next: (value: Array<any>) => {
        this.campaign = value
      },
    });
  }

  /** The icon of a campaign card by channel; a Hybrid ("Split") channel carries its own seal. */
  campaignChannelIcon(item: Campaign): string {
    switch (item.type) {
      case ChannelTypeEnum.CLOUD_API: return channelIconOf(item);
      case ChannelTypeEnum.RCS_API: return CHANNEL_ICONS[ChannelTypeEnum.RCS_API];
      default: return '/assets/images/icon-whatsapp.svg';
    }
  }

  openModalAttendance(status: string): void {
    const refBottom = this.dialog.open(ModalResponseAttendanceComponent, {
      width: '70rem',
      height: '40rem',
      data: {
        status: status,
        dateStart: this.dashForm.value.dateRange.dateStart,
        dateEnd: this.dashForm.value.dateRange.dateEnd,
        department:
          this.dashForm.value.department === -1
            ? null
            : this.dashForm.value.department,
        attendant:
          this.dashForm.value.attendant === -1
            ? null
            : this.dashForm.value.attendant,
        channel:
          this.dashForm.value.channel === -1
            ? null
            : this.dashForm.value.channel,
      },
    });

    refBottom.afterClosed();
  }

  transform(birthDate: Date | string): number {
    if (!birthDate) return 0;
    const birth = new Date(birthDate);
    const today = new Date();
    let age = today.getFullYear() - birth.getFullYear();
    const monthDiff = today.getMonth() - birth.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birth.getDate())
    ) {
      age--;
    }
    return age;
  }

  calculatePercentage(limitAttendancePerAttendant: boolean, limite: number, totalAtendimento: number): number {
    if (limite === 0 || !limitAttendancePerAttendant) {
      return 0;
    }
    const percentage = (totalAtendimento / limite) * 100;
    const value = Math.min(percentage, 100);
    if (value >= 50 && value < 90) {
      return 1;
    }
    if (value >= 90) {
      return 2;
    }
    return 0;
  }

  formatPercentage(value: number): string {
    return `${value.toFixed(1)}%`;
  }

  onChannelSelect(value: any, label?: string): void {
    this.dashForm.get('channel')?.setValue(value);
    this.labelChannel = label ?? '';

    // changing the channel invalidates any department/attendant already chosen
    this.resetDepartmentSelection();
    this.resetAttendantSelection();

    if (this.isSupervisor()) {
      this.buildTeamsByChannel(value);
    } else {
      this.getDepartmentByChannel();
    }
  }

  onDepartmentSelect(value: any, label?: string): void {
    this.dashForm.get('department')?.setValue(value);
    this.labelDepartment = label ?? '';

    // changing the department invalidates the attendant already chosen
    this.resetAttendantSelection();
    this.getAttendantsByDepartment(value);
  }

  onAttendantSelect(value: any, label?: string): void {
    this.dashForm.get('attendant')?.setValue(value);
    this.labelAttendant = label ?? '';
  }

  private resetDepartmentSelection(): void {
    this.dashForm.get('department')?.setValue(-1);
    this.labelDepartment = '';
  }

  private resetAttendantSelection(): void {
    this.dashForm.get('attendant')?.setValue(-1);
    this.labelAttendant = '';
    this.attendantsByTeam = [];
  }

  private buildTeamsByChannel(channelId: any): void {
    if (!channelId || channelId === -1) {
      this.listTeamChannel = [];
      return;
    }
    this.listTeamChannel = (this.listTeam ?? [])
      .filter((team: Team) => team.department?.channel?.toString() === channelId);
  }

  private getAttendantsByDepartment(idDepartment: any): void {
    if (!idDepartment || idDepartment === -1) {
      this.attendantsByTeam = [];
      return;
    }

    if (this.isAdmin()) {
      this.teamService.getList().pipe(takeUntil(this.destroy$)).subscribe({
        next: (teams: Array<Team>) => {
          this.attendantsByTeam = teams
            .filter((team: Team) => team.department?._id === idDepartment && team.agents?.length)
            .flatMap((team: Team) => team.agents);
        },
      });
    } else if (this.isSupervisor()) {
      this.attendantsByTeam = (this.listTeam ?? [])
        .filter((team: Team) => team.department?._id === idDepartment && team.agents?.length)
        .flatMap((team: Team) => team.agents);
    }
  }

  getOnlineUsersByCompany(): void {
    this.userService
      .getOnlineUsersByCompany(this.getIDCurrentCompany())
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (values: any[]) => {
          this.onlineUsers = values;
        },
      });
  }

  get attendantsInScope(): User[] {
    const department = this.dashForm?.get('department')?.value;
    if (department && department !== -1) {
      return this.attendantsByTeam ?? [];
    }

    const channel = this.dashForm?.get('channel')?.value;
    const teams = (this.listTeam ?? []).filter((team: Team) =>
      !channel || channel === -1 || team.department?.channel?.toString() === channel
    );
    return this.uniqueAgents(teams);
  }

  private uniqueAgents(teams: Array<Team>): User[] {
    const agents = new Map<string, User>();
    teams.forEach((team: Team) =>
      (team.agents ?? []).forEach((agent: User) => {
        if (agent?._id) agents.set(agent._id, agent);
      })
    );
    return [...agents.values()];
  }

  getNumberOnline(): number {
    return this.attendantsInScope.filter((user: User) => this.isUserOnline(user.email)).length;
  }

  isUserOnline(email: string): boolean {
    return this.onlineUsers.includes('users:authed:json:' + email);
  }

  // ---------------------------------------------------------------------------
  // Attendance dashboard — live cards and period overview
  // ---------------------------------------------------------------------------

  getAttendancesLive({ department, attendant, channel }): void {
    this.dashboardService.getAttendancesLive(department, attendant, channel)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (snapshot: AttendanceLiveSnapshot) => (this.attendanceLive = snapshot),
      });
  }

  getAttendancesOverview({ dateStart, dateEnd, department, attendant, channel }): void {
    this.dashboardService.getAttendancesOverview(dateStart, dateEnd, department, attendant, channel)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (overview: AttendanceDashboardOverview) => {
          this.overview = overview;
          this.buildOverviewCharts(overview);
        },
      });
  }

  /** Turn the overview's rows into the series ngx-charts draws. */
  private buildOverviewCharts(overview: AttendanceDashboardOverview): void {
    const withinLabel = this.t('dashboard.dashboard.withinBusinessHours');
    const outsideLabel = this.t('dashboard.dashboard.outsideBusinessHours');

    this.arrivalsByHourSeries = (overview.arrivalsByHour ?? []).map((hour) => ({
      name: `${String(hour.hour).padStart(2, '0')}:00`,
      series: [
        { name: withinLabel, value: hour.within },
        { name: outsideLabel, value: hour.outside },
      ],
    }));
  }

  // ---------------------------------------------------------------------------
  // Where the customer's time goes
  // ---------------------------------------------------------------------------

  /** The departments on screen: the busiest ones, or all of them. */
  get journeyRows(): Array<DepartmentJourney> {
    const rows = (this.overview?.journey ?? []).filter((row) => row.totalMinutes !== null);
    return this.showAllJourney ? rows : rows.slice(0, this.journeyPreviewSize);
  }

  get hiddenJourneyCount(): number {
    const rows = (this.overview?.journey ?? []).filter((row) => row.totalMinutes !== null);
    return Math.max(0, rows.length - this.journeyPreviewSize);
  }

  toggleJourney(): void {
    this.showAllJourney = !this.showAllJourney;
  }

  /**
   * One segment of a department's bar, as a share of the LONGEST journey on screen — so the
   * bars compare with each other instead of each one filling its own row.
   */
  journeyShare(minutes: number | null): number {
    const longest = Math.max(
      0,
      ...(this.overview?.journey ?? []).map((row) => row.totalMinutes ?? 0),
    );
    if (!longest || !minutes) {
      return 0;
    }
    return (minutes / longest) * 100;
  }

  /**
   * New contacts per channel, biggest first. The bar is sized against the BIGGEST channel so
   * the lengths compare with each other; the text carries the share of the whole, which is
   * the number someone actually quotes.
   */
  get newContactRows(): Array<{ name: string; value: number; percent: number; share: number }> {
    const rows = (this.newContact ?? [])
      .map((row: any) => ({ name: row.name as string, value: Number(row.value ?? 0) }))
      .filter((row) => row.value > 0)
      .sort((a, b) => b.value - a.value);

    const total = rows.reduce((sum, row) => sum + row.value, 0);
    const biggest = rows.length ? rows[0].value : 0;

    return rows.map((row) => ({
      ...row,
      percent: total ? (row.value / total) * 100 : 0,
      share: biggest ? (row.value / biggest) * 100 : 0,
    }));
  }

  waitingBandLabel(key: string): string {
    return this.t('dashboard.dashboard.waitingBand' + this.capitalize(key));
  }

  private capitalize(value: string): string {
    return value ? value.charAt(0).toUpperCase() + value.slice(1) : '';
  }

  setRhythmView(view: RhythmView): void {
    this.rhythmView = view;
    // The charts are drawn at a width measured from their host. Measure AFTER the new view
    // has been laid out: reading it during the change detection that swaps the branch
    // returns the width of the branch leaving the screen — which is how a half-width
    // weekday chart ended up drawn at the full width of the card.
    setTimeout(() => this.resizeAllCharts(), 0);
  }

  toggleInsights(): void {
    this.showAllInsights = !this.showAllInsights;
  }

  /**
   * The eight readings, in order. Seven come from the API; the last is built here, from the
   * very series the weekday chart draws, so the chart and the reading cannot disagree about
   * which day brought the most new contacts.
   */
  get allInsights(): Array<AttendanceInsight> {
    const fromApi = this.overview?.insights ?? [];
    if (!fromApi.length) {
      return [];
    }
    const newContacts = this.newContactsInsight();
    return newContacts ? [...fromApi, newContacts] : fromApi;
  }

  /** The readings on screen: the four main ones, or all eight. */
  get visibleInsights(): Array<AttendanceInsight> {
    const insights = this.allInsights;
    return this.showAllInsights ? insights : insights.filter((insight) => insight.primary);
  }

  /** Which weekday brought the most new contacts, read off the chart's own series. */
  private newContactsInsight(): AttendanceInsight | null {
    const series = this.newContactWeekend ?? [];
    if (!series.length) {
      return null;
    }
    const total = series.reduce((sum, day) => sum + Number(day.value ?? 0), 0);
    const busiest = series.reduce(
      (best, day) => (Number(day.value ?? 0) > Number(best.value ?? 0) ? day : best),
      series[0],
    );
    return {
      key: 'newContactsWeekday',
      // Already a translated weekday label, so it travels as text.
      value: Number(busiest.value ?? 0) ? busiest.name : null,
      unit: 'TEXT',
      params: { count: Number(busiest.value ?? 0), total },
      primary: false,
    };
  }

  /** The sentence of one reading, translated with the numbers the API sent. */
  insightText(insight: AttendanceInsight): string {
    return this.t('dashboard.dashboard.insight' + this.capitalize(insight.key) + 'Text', this.insightParams(insight));
  }

  insightTitle(insight: AttendanceInsight): string {
    return this.t('dashboard.dashboard.insight' + this.capitalize(insight.key) + 'Title', this.insightParams(insight));
  }

  /**
   * The headline figure of a reading. The API sends the number and says what it is; the
   * decimal separator and the weekday name belong to whoever is reading the screen.
   */
  insightValue(insight: AttendanceInsight): string {
    // The one reading the API cannot finish: how many customers each online agent carries
    // depends on who the current channel/department filter puts in scope and who Redis
    // reports as online, and only the screen knows both.
    if (insight.key === 'queuePerAgent') {
      const agents = this.getNumberOnline();
      const queue = Number(insight.params?.['queue'] ?? 0);
      return agents > 0 ? this.formatDecimal(queue / agents) : this.formatNumber(queue);
    }

    if (insight.value === null || insight.value === undefined) {
      return '—';
    }

    switch (insight.unit) {
      case 'PERCENT':
        return this.formatPercent(Number(insight.value));
      case 'COUNT':
        return this.formatNumber(Number(insight.value));
      case 'HOUR':
        return `${String(Number(insight.value)).padStart(2, '0')}:00`;
      case 'WEEKDAY':
        return this.weekdayLabel(Number(insight.value));
      default:
        return String(insight.value);
    }
  }

  /**
   * The numbers the translated sentence interpolates. A `share` arrives as a raw percentage
   * and is formatted here, for the same reason `value` is.
   */
  private insightParams(insight: AttendanceInsight): Record<string, string | number> {
    const params: Record<string, string | number> = {};

    Object.entries(insight.params ?? {}).forEach(([name, value]) => {
      if (name === 'share') {
        params[name] = typeof value === 'number' ? this.formatPercent(value) : '—';
        return;
      }
      params[name] = value === null || value === undefined ? '—' : value;
    });

    if (insight.key === 'queuePerAgent') {
      params['agents'] = this.getNumberOnline();
    }
    return params;
  }

  /** One decimal place, with the separator the locale uses. */
  private formatDecimal(value: number): string {
    return Number.isFinite(value) ? value.toFixed(1).replace('.', ',') : '—';
  }

  // ---------------------------------------------------------------------------
  // Formatting
  // ---------------------------------------------------------------------------

  /**
   * Minutes as `HH:MM:SS`, the format the time cards have always used. A metric with no
   * sample shows a dash — printing `00:00:00` would read as "answered instantly".
   */
  formatMinutes(minutes: number | null | undefined): string {
    if (minutes === null || minutes === undefined || !Number.isFinite(minutes)) {
      return '—';
    }
    const totalSeconds = Math.max(0, Math.round(minutes * 60));
    const hours = Math.floor(totalSeconds / 3600);
    const mins = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;
    return [hours, mins, secs].map((part) => String(part).padStart(2, '0')).join(':');
  }

  formatPercent(value: number | null | undefined, fractionDigits = 1): string {
    if (value === null || value === undefined || !Number.isFinite(value)) {
      return '—';
    }
    return `${value.toFixed(fractionDigits).replace('.', ',')}%`;
  }

  formatSigned(value: number | null | undefined): string {
    if (value === null || value === undefined || !Number.isFinite(value)) {
      return '—';
    }
    const prefix = value > 0 ? '+' : '';
    return `${prefix}${value.toFixed(0)}%`;
  }

  formatNumber(value: number | null | undefined): string {
    if (value === null || value === undefined || !Number.isFinite(value)) {
      return '—';
    }
    return value.toLocaleString('pt-BR');
  }

  formatCsat(value: number | null | undefined): string {
    return value === null || value === undefined ? '—' : value.toFixed(2);
  }

  /** The shared status badge of the design system — never a hand-styled pill. */
  statusBadgeClass(status: GoalStatus): string {
    switch (status) {
      case 'CRITICAL':
        return 'is-err';
      case 'ATTENTION':
        return 'is-warn';
      default:
        return 'is-ok';
    }
  }

  statusTextClass(status: GoalStatus): string {
    switch (status) {
      case 'CRITICAL':
        return 'text-danger';
      case 'ATTENTION':
        return 'text-warning';
      default:
        return 'text-success';
    }
  }

  statusLabel(status: GoalStatus): string {
    switch (status) {
      case 'CRITICAL':
        return this.t('dashboard.dashboard.statusCritical');
      case 'ATTENTION':
        return this.t('dashboard.dashboard.statusAttention');
      default:
        return this.t('dashboard.dashboard.statusOk');
    }
  }

  /** The live cards colour themselves from their own thresholds, not from a goal. */
  queueStatus(): GoalStatus {
    const queue = this.attendanceLive?.queueNow ?? 0;
    const limit = this.attendanceLive?.queueAlertAt ?? 10;
    if (queue > limit * 2) return 'CRITICAL';
    return queue > limit ? 'ATTENTION' : 'OK';
  }

  countStatus(value: number, attentionAt: number, criticalAt: number): GoalStatus {
    if (value >= criticalAt) return 'CRITICAL';
    return value >= attentionAt ? 'ATTENTION' : 'OK';
  }

  journeyCaption(bottleneck: string): string {
    switch (bottleneck) {
      case 'QUEUE':
        return this.t('dashboard.dashboard.bottleneckQueue');
      case 'HANDLING':
        return this.t('dashboard.dashboard.bottleneckHandling');
      case 'BALANCED':
        return this.t('dashboard.dashboard.bottleneckBalanced');
      default:
        return '';
    }
  }

  /** Percentage of an attendant's chats already closed — a derived column of the table. */
  closedShare(row: any): string {
    return Number(row?.totalChat ?? 0) ? this.formatPercent(row.closedSharePercent, 0) : '—';
  }

  messagesPerChat(row: any): string {
    return Number(row?.totalChat ?? 0)
      ? Number(row.messagesPerChatValue).toFixed(1).replace('.', ',')
      : '—';
  }

  // ---------------------------------------------------------------------------
  // Goals configuration
  // ---------------------------------------------------------------------------

  private createGoalsForm(): void {
    this.goalsForm = this.fb.group({
      averageTicket: [0],
      conversionWithinDeadline: [0],
      firstResponseMinutes: [0],
      slaTarget: [0],
      tmaMinutes: [0],
      abandonmentMax: [0],
      monthlySalesTarget: [0],
    });
  }

  private loadGoals(): void {
    this.dashboardService.getAttendanceGoals().pipe(takeUntil(this.destroy$)).subscribe({
      next: (payload: AttendanceGoalsPayload) => this.applyGoalsPayload(payload),
    });
  }

  private applyGoalsPayload(payload: AttendanceGoalsPayload): void {
    this.goalsPayload = payload;
    this.goalsForm.patchValue(payload.goals);
  }

  /** Copy one market suggestion into its field — the "Usar sugestão" button of each goal. */
  useSuggestion(field: keyof AttendanceGoalsConfig): void {
    const suggestion = this.goalsPayload?.suggestions?.[field];
    if (suggestion !== undefined) {
      this.goalsForm.get(field as string)?.setValue(suggestion);
    }
  }

  suggestionOf(field: keyof AttendanceGoalsConfig): number {
    return this.goalsPayload?.suggestions?.[field] ?? 0;
  }

  saveGoals(): void {
    this.savingGoals = true;
    this.dashboardService.saveAttendanceGoals(this.goalsForm.value as AttendanceGoalsConfig)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (payload: AttendanceGoalsPayload) => {
          this.applyGoalsPayload(payload);
          this.alertService.success(this.t('dashboard.dashboard.goalsSaved'));
          this.fetchData();
        },
        error: () => this.alertService.error(this.t('dashboard.dashboard.goalsSaveError')),
        complete: () => (this.savingGoals = false),
      });
  }

  resetGoals(): void {
    this.savingGoals = true;
    this.dashboardService.resetAttendanceGoals()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (payload: AttendanceGoalsPayload) => {
          this.applyGoalsPayload(payload);
          this.alertService.success(this.t('dashboard.dashboard.goalsReset'));
          this.fetchData();
        },
        error: () => this.alertService.error(this.t('dashboard.dashboard.goalsSaveError')),
        complete: () => (this.savingGoals = false),
      });
  }
}
